
import { Component, Prop, Vue } from 'vue-property-decorator';
import Client from '@/models/Client';
import Project from '@/models/Project';
import Offer from '@/models/Offer';
import { RouteNames } from '@/enums/routes/RouteNames';
import { ClientTabs } from '@/enums/components/EditClient/ClientTabs';
import { generateStateSpecificId } from '@/helpers/project/ProjectHelper';
import OfferRepository from '@/repositories/OfferRepository';
import BlockedTag from '@/components/global/BlockedTag.vue';

@Component({
    name: 'ProjectDynamicInfoBar',
    components: {
        BlockedTag
    },
})
export default class ProjectDynamicInfoBar extends Vue {
    @Prop({ required: true }) private client!: Client | null;
    @Prop({ required: true }) private project!: Project | null;
    @Prop({ default: null }) private projectId!: string;
    @Prop({ required: false }) private basicStateSpecificId!: string;
    @Prop({ required: false }) private basicProjectData!: any;
    @Prop({ required: false }) private orderNumber!: string;

    private selectedOffer: Offer | null = null;

    private get clientRoute() {
        if (!this.client && !this.basicProjectData.clientId) {
            return '';
        }

        return {
            name: RouteNames.editClient,
            params: {
                clientId: this.client?.id ?? this.basicProjectData?.clientId,
                initialTab: ClientTabs.CUSTOMER,
            },
        };
    }

    private get stateSpecificId() {
        if (this.orderNumber && this.orderNumber !== '-') {
            return this.orderNumber;
        }

        this.selectedOffer = OfferRepository.getSelectedOffer(this.projectId) as Offer;
        return generateStateSpecificId(this.project, this.selectedOffer);
    }
}
